module.exports = __webpack_public_path__ + "static/media/Login.5e06794f.png";